import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import { TextField, Grid } from '@mui/material';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
  inputRow: {
    marginBottom: 8,
  },
});

const DEFAULT_ADDRESS_FIELD_CONFIG = {
  line1: { show: true, required: true },
  line2: { show: true, required: false },
  locality: { show: true, required: true },
  region: { show: true, required: true },
  postalCode: { show: true, required: true },
  country: { show: true, required: true },
};

const Address = ({ classes, data }) => {
  const addressFields = {
    ...DEFAULT_ADDRESS_FIELD_CONFIG,
    ...(data?.addressFields || {}),
  };

  return (
    <div className={classes.root}>
      {addressFields.line1?.show && (
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          disabled
          placeholder="Address line 1"
          className={classes.inputRow}
        />
      )}
      {addressFields.line2?.show && (
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          disabled
          placeholder="Address line 2"
          className={classes.inputRow}
        />
      )}

      <Grid container spacing={1}>
        {addressFields.locality?.show && (
          <Grid item xs={addressFields.region?.show ? 6 : 12}>
            <TextField fullWidth variant="outlined" size="small" disabled placeholder="City / Locality" />
          </Grid>
        )}
        {addressFields.region?.show && (
          <Grid item xs={addressFields.locality?.show ? 6 : 12}>
            <TextField fullWidth variant="outlined" size="small" disabled placeholder="State / Region" />
          </Grid>
        )}
      </Grid>
      <Grid container spacing={1} style={{ marginTop: 8 }}>
        {addressFields.postalCode?.show && (
          <Grid item xs={addressFields.country?.show ? 6 : 12}>
            <TextField fullWidth variant="outlined" size="small" disabled placeholder="Postal / ZIP code" />
          </Grid>
        )}
        {addressFields.country?.show && (
          <Grid item xs={addressFields.postalCode?.show ? 6 : 12}>
            <TextField fullWidth variant="outlined" size="small" disabled placeholder="Country" />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

Address.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
};

export default withStyles(styles)(Address);
